import RootLink from 'Root/Component/Link'
import { useRouter } from 'next/router'

import styles from './index.module.css'

interface Props {
  children: React.ReactNode
}

const Link = ({ children }: Props) => {
  const router = useRouter()

  if ('/' === router.pathname) {
    return (
      <a className={styles.link} href="/">
        {children}
      </a>
    )
  }

  return (
    <RootLink className={styles.link} to="/">
      {children}
    </RootLink>
  )
}

export default Link
